"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var HoverCard_styles_1 = require("./HoverCard.styles");
var HoverCard_base_1 = require("./HoverCard.base");
exports.HoverCard = Utilities_1.styled(HoverCard_base_1.HoverCardBase, HoverCard_styles_1.getStyles, undefined, {
    scope: 'HoverCard'
});
//# sourceMappingURL=HoverCard.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/HoverCard/HoverCard.js
// module id = 1054
// module chunks = 0